import React, { useState } from 'react';
import { updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
import { auth } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

export default function AccountPage() {
  const { user, role, pharmacy } = useAuth();
  const [current, setCurrent] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const changePassword = async () => {
    setMsg(''); setErr('');
    if (newPass !== confirm) { setErr('Passwords do not match.'); return; }
    if (newPass.length < 6) { setErr('Password must be at least 6 characters.'); return; }
    try {
      const cred = EmailAuthProvider.credential(user.email, current);
      await reauthenticateWithCredential(user, cred);
      await updatePassword(user, newPass);
      setMsg('Password updated successfully.');
      setCurrent(''); setNewPass(''); setConfirm('');
    } catch (e) {
      setErr(e.code === 'auth/wrong-password' ? 'Current password is incorrect.' : 'Failed to update password.');
    }
  };

  return (
    <div style={{ padding: '28px 32px', fontFamily: 'Inter, system-ui, sans-serif', maxWidth: 520 }}>
      <h1 style={{ margin: '0 0 4px', fontSize: 24, fontWeight: 800, color: '#0F172A' }}>Account Info</h1>
      <p style={{ margin: '0 0 28px', fontSize: 13, color: '#94A3B8' }}>Your profile and security settings</p>

      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #E2E8F0', padding: 28, marginBottom: 20 }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700, color: '#0F172A' }}>Profile</h3>
        <div style={{ display: 'grid', gap: 10 }}>
          {[['Email', user?.email], ['Role', role], ['Pharmacy', pharmacy?.name || '—']].map(([k, v]) => (
            <div key={k} style={{ display: 'flex', fontSize: 13 }}>
              <span style={{ color: '#94A3B8', width: 100, flexShrink: 0 }}>{k}</span>
              <span style={{ color: '#0F172A', fontWeight: 500 }}>{v}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #E2E8F0', padding: 28 }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700, color: '#0F172A' }}>Change Password</h3>
        {err && <div style={{ padding: '8px 12px', background: '#FEE2E2', color: '#DC2626',
          borderRadius: 8, fontSize: 13, marginBottom: 14 }}>{err}</div>}
        {msg && <div style={{ padding: '8px 12px', background: '#DCFCE7', color: '#16A34A',
          borderRadius: 8, fontSize: 13, marginBottom: 14 }}>{msg}</div>}
        {[['Current Password', current, setCurrent], ['New Password', newPass, setNewPass],
          ['Confirm New Password', confirm, setConfirm]].map(([label, val, setter]) => (
          <div key={label} style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#374151', marginBottom: 5 }}>{label}</label>
            <input type="password" value={val} onChange={e => setter(e.target.value)}
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #D1D5DB',
                borderRadius: 8, fontSize: 14, boxSizing: 'border-box', background: '#F9FAFB' }} />
          </div>
        ))}
        <button onClick={changePassword} style={{
          padding: '10px 24px', background: '#0F172A', color: '#fff',
          border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer'
        }}>Update Password</button>
      </div>
    </div>
  );
}
